const ACTION_TYPES_BASE_NAME = "chromecast";

export const actionTypes = {
  CONNECTION_STATE_CHANGED: `${ACTION_TYPES_BASE_NAME}/CONNECTION_STATE_CHANGED`,
  CONTENT_CHANGED: `${ACTION_TYPES_BASE_NAME}/CONTENT_CHANGED`,
  CONTENT_LOADED: `${ACTION_TYPES_BASE_NAME}/CONTENT_LOADED`,
  LIBRARY_LOADED: `${ACTION_TYPES_BASE_NAME}/LIBRARY_LOADED`,
  LOAD_MEDIA: `${ACTION_TYPES_BASE_NAME}/LOAD_MEDIA`,
  PAGE_UNLOADED: `${ACTION_TYPES_BASE_NAME}/PAGE_UNLOADED`,
  RECEIVER_CONTENT_CHANGED: `${ACTION_TYPES_BASE_NAME}/RECEIVER_CONTENT_CHANGED`
};

export const connectionStateChanged = (state) => ({
  type: actionTypes.CONNECTION_STATE_CHANGED,
  payload: state
});

export const contentChanged = (content) => ({
  type: actionTypes.CONTENT_CHANGED,
  payload: content
});

export const contentLoaded = () => ({ type: actionTypes.CONTENT_LOADED });
export const libraryLoaded = () => ({ type: actionTypes.LIBRARY_LOADED });

export const loadMedia = (assetId, assetType, isLive, playSource, progress) => ({
  type: actionTypes.LOAD_MEDIA,
  payload: { assetId, assetType, isLive, playSource, progress }
});

export const loadMediaFromPlayer = (isLive, progress) => ({
  type: actionTypes.LOAD_MEDIA,
  payload: { fromPlayer: true, isLive, progress }
});

export const pageUnloaded = (remotePlayer) => ({
  type: actionTypes.PAGE_UNLOADED,
  payload: remotePlayer
});

export const receiverContentChanged = (content) => ({
  type: actionTypes.RECEIVER_CONTENT_CHANGED,
  payload: content
});
